import httpUtils from '../utils/HttpUtils'
import HttpUtilsGangmasterSeek from '../utils/HttpUtilsGangmasterSeek'

class SupervisorService {

  //监理、工长、保洁、搬家列表
  async getSupervisorList (type,synthesizeSortType = '',areaId = '', decorateType = '') {
    var result = null;
    try {
      result = await httpUtils.post('/server/supervisor/list',{type,synthesizeSortType,areaId,decorateType})
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //监理、工长、保洁、搬家详情
  async getSupervisorDetail (supervisorId) {
    var result = null;
    try {
      result = await httpUtils.post('/server/supervisor/detail',{supervisorId:supervisorId});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  // 优选工长超链接
  async getLinkList (position) {
    var result = null;
    try {
      result = await HttpUtilsGangmasterSeek.post('/app/link/list',{position:position});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  // 优选工长超链接详情
  async getLinkDetail (linkId) {
    var result = null;
    try {
      result = await HttpUtilsGangmasterSeek.post('/app/link/get',{linkId});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }
}
export default new SupervisorService()
